import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import persistentCachePlugin from './plugin'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

/**
 * 需要把store中的数据存放到本地 列表
 * stateName： store中的字段名字
 * updateName： store中更新数据的方法名
 * cacheKey 存入本地的字段名
 * */
const whiteList = [
  {
    stateName: 'tagsView/visitedViews',
    updateName: 'tagsView/UPDATE_VISITED_VIEW',
    cacheKey: 'visited_views'
  },
  {
    stateName: 'tagsView/visitedViews',
    updateName: 'tagsView/ADD_VISITED_VIEW',
    cacheKey: 'visited_views',
    isInit: true
  },
  {
    stateName: 'tagsView/visitedViews',
    updateName: 'tagsView/DEL_VISITED_VIEW',
    cacheKey: 'visited_views'
  },
  {
    stateName: 'tagsView/visitedViews',
    updateName: 'tagsView/DEL_OTHERS_VISITED_VIEWS',
    cacheKey: 'visited_views'
  },
  {
    stateName: 'tagsView/visitedViews',
    updateName: 'tagsView/DEL_ALL_VISITED_VIEWS',
    cacheKey: 'visited_views'
  }
]
Vue.config.devtools = true
const store = new Vuex.Store({
  plugins: [persistentCachePlugin(whiteList)],
  modules,
  getters
})

export default store
